import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__Container_module_js_7d6074ca__ from "./Container.module.js";
function Container(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: __WEBPACK_EXTERNAL_MODULE__Container_module_js_7d6074ca__["default"].container,
        ...props
    });
}
export { Container as default };

//# sourceMappingURL=Container.js.map